import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        user: '=',
        inactivityPeriodId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Inactive period' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <form-row error="vm.form.errors.inactivityPeriods[0].start">
                    <label class="label">{{ 'user.From' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.dateStart"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.inactivityPeriods[0].end">
                    <label class="label">{{ 'user.To' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-model="vm.dateEnd"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.inactivityPeriods[0].description">
                    <label class="label">{{ 'user.Description' | translate }}</label>
                    <div class="items">
                        <textarea ng-model="vm.description" class="form-control"></textarea>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, moment, FormFactory, UserResource) {
        this.FormFactory = FormFactory;
        this.lodash = lodash;
        this.moment = moment;
        this.UserResource = UserResource;
    }

    $onInit () {
        this.initInactivityPeriods();
        this.createForm();
    }

    initInactivityPeriods () {
        this.dateStart = undefined;
        this.dateEnd = undefined;
        this.description = undefined;
        if (this.inactivityPeriodId) {
            // find correct object from array to display on form
            const inactivityPeriod = this.lodash.find(this.user.inactivityPeriods, { id: this.inactivityPeriodId });

            this.dateStart = inactivityPeriod.start;
            this.dateEnd = inactivityPeriod.end;
            this.description = inactivityPeriod.description;
        }
    }

    createForm () {
        this.form = this.FormFactory.create(this.user, model => model.$update({ id: model.id }));
    }

    beforeSave () {
        this.form.model.inactivityPeriods = [];
        this.form.model.inactivityPeriods.push({
            id: this.inactivityPeriodId,
            start: this.dateStart,
            end: this.dateEnd,
            description: this.description
        });
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then(() => {
                this.onUpdate();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/inactivityPeriods/index.js